<script setup lang="ts"></script>

<template>
  <icon name="lucide:arrow-right" />
</template>

<style scoped></style>
